export type ReportsChannel = {
  channel_name: string
  channel_icon: string
  form_submits: number
  leads: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
}

export type ReportsSum = {
  form_submits: number
  leads: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
  stats_channel_id?: number
  total_count?: number
}

export type PagesSum = {
  form_submits: number
  leads: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
}

export type ReportsAdsSum = {
  form_submits: number
  leads: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
  ad_spend: number
}

export type PageFormated = {
  key: string
  unique: number
  form: number
  order: number
  sale: number
  url: string
}

export type ReportsPageTotal = {
  page_id: number
}

export type ReportsChannelsTotal = {
  source_id: number
}

export type ReportsPage = {
  page_href: string
  page_page_id: string
  form_submits: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
  leads: number
}

export type SourceFormated = {
  key: string
  unique: number
  form: number
  order: number
  sale: number
  name?: string
  set_id?: string
  campaign_id?: string
  impression?: number
  spend?: number
  cpc?: string
  roas?: string
}

export type ReportsOrganic = {
  form_submits: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
  leads: number
  utm_source_source_id?: string
  utm_campaign: string
  utm_content: string
  utm_medium: string
  utm_source: string
}

export type ReportsAds = {
  form_submits: number
  total_orders: number
  total_amount: number
  recurring_payments_amount: number
  orders_amount: number
  views: number
  leads: number
  ad_source_source_id: string
  ad_source_ad_name: string
  ad_campaign_ad_campaign_name: string
  ad_campaign_ad_campaign_id?: string
  ad_set_ad_set_name: string
  ad_set_ad_set_id?: string
  ad_set_ad_campaign_id?: string
  ad_impressions: number
  ad_spend: number
}

export type SortBy =
  | 'views'
  | 'form_submits'
  | 'leads'
  | 'total_orders'
  | 'total_amount'
  | 'ad_impressions'
  | 'ad_spend'
export type SortType = 'ASC' | 'DESC'

export type Sort = {
  sortBy?: SortBy
  sortType?: SortType
}

/** Types that map directly to additive columns in ChannelEvent rows. */
export type ChartableStatsType =
  | 'views'
  | 'new_visitors'
  | 'new_customers'
  | 'form_submits'
  | 'leads'
  | 'total_orders'
  | 'total_amount'
  | 'recurring_payments_amount'
  | 'orders_amount'

export type StatsType = ChartableStatsType
export type Attribution = 'first' | 'last' | 'linear' | 'ai'

// export type SalesStats =
//   | 'total_amount'
//   | 'recurring_payments_amount'
//   | 'orders_amount'

export enum SalesStats {
  TotalAmount = 'total_amount',
  RecurringPaymentsAmount = 'recurring_payments_amount',
  OrdersAmount = 'orders_amount',
}

export function isSalesStats(value: unknown): value is SalesStats {
  return Object.values(SalesStats).includes(value as SalesStats)
}

type DataProt = {
  views: number[]
  new_visitors: number[]
  new_customers: number[]
  form_submits: number[]
  leads: number[]
  total_orders: number[]
  total_amount: number[]
  recurring_payments_amount: number[]
  orders_amount: number[]
  dates: string[]
}

export interface FormattedStats {
  day: DataProt
  week: DataProt
  month: DataProt
  views_sum: number
  new_visitors_sum: number
  new_customers_sum: number
  form_submits_sum: number
  leads_sum: number
  total_orders_sum: number
  total_amount_sum: number
  recurring_payments_amount_sum: number
  orders_amount_sum: number
  avg_source_touches_at_lead_sum?: number
  avg_source_touches_at_order_sum?: number
}
